
import React from "react";
import { MousePointer, Puzzle } from "lucide-react";

/**
 * Insert tool component HTML into editor content
 */
export const insertToolComponent = (
  toolName: string,
  value: string,
  onChange: (value: string) => void,
  theme: string = 'default',
  postId?: string
) => {
  const textarea = document.getElementById("html-editor") as HTMLTextAreaElement;
  if (!textarea) return;
  
  let toolHtml = '';
  
  switch (toolName) {
    case 'craftGenerator':
      // Create a div with ID and script to embed the craft generator
      const craftId = `elf-craft-generator-${Date.now()}`;
      toolHtml = `
<div id="${craftId}" class="elf-tool-container"></div>
<script>
  (function() {
    // Wait for the embedElfCraftGenerator function to be available
    function checkForEmbedFunction() {
      if (window.embedElfCraftGenerator) {
        window.embedElfCraftGenerator("${craftId}", "${theme}"${postId ? `, "${postId}"` : ''});
      } else {
        setTimeout(checkForEmbedFunction, 500);
      }
    }
    checkForEmbedFunction();
  })();
</script>`;
      break;
    case 'sceneGenerator':
      // Create a div with ID and script to embed the scene generator
      const sceneId = `elf-scene-generator-${Date.now()}`;
      toolHtml = `
<div id="${sceneId}" class="elf-tool-container"></div>
<script>
  (function() {
    // Wait for the embed function to be available
    function checkForEmbedFunction() {
      if (window.embedElfSceneGenerator) {
        window.embedElfSceneGenerator("${sceneId}", "${theme}"${postId ? `, "${postId}"` : ''});
      } else {
        setTimeout(checkForEmbedFunction, 500);
      }
    }
    checkForEmbedFunction();
  })();
</script>`;
      break;
    case 'recipeGenerator':
      // Create a div with ID and script to embed the recipe generator
      const recipeId = `elf-recipe-generator-${Date.now()}`;
      toolHtml = `
<div id="${recipeId}" class="elf-tool-container"></div>
<script>
  (function() {
    // Wait for the embed function to be available
    function checkForEmbedFunction() {
      if (window.embedElfRecipeGenerator) {
        window.embedElfRecipeGenerator("${recipeId}", "${theme}"${postId ? `, "${postId}"` : ''});
      } else {
        setTimeout(checkForEmbedFunction, 500);
      }
    }
    checkForEmbedFunction();
  })();
</script>`;
      break;
    default:
      toolHtml = `<div>Unknown tool: ${toolName}</div>`;
  }
  
  const startPos = textarea.selectionStart;
  const newValue = 
    value.substring(0, startPos) + 
    toolHtml + 
    value.substring(startPos);
  
  onChange(newValue);
  
  setTimeout(() => {
    textarea.focus();
    const newCursorPos = startPos + toolHtml.length;
    textarea.setSelectionRange(newCursorPos, newCursorPos);
  }, 0);
};

/**
 * Toolbar actions for editor tools
 */
export const createToolbarToolActions = (
  value: string,
  onChange: (value: string) => void,
  theme: string = 'default',
  postId?: string
) => {
  return [
    { 
      icon: <Puzzle size={18} />, 
      title: "Insert Holiday Elf Craft Generator", 
      action: () => insertToolComponent('craftGenerator', value, onChange, theme, postId) 
    },
    { 
      icon: <Puzzle size={18} />, 
      title: "Insert Holiday Elf Scene Generator", 
      action: () => insertToolComponent('sceneGenerator', value, onChange, theme, postId) 
    },
    { 
      icon: <Puzzle size={18} />, 
      title: "Insert Holiday Elf Recipe Generator", 
      action: () => insertToolComponent('recipeGenerator', value, onChange, theme, postId) 
    },
    // More tools can be added here in the future
  ];
};
